/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from native/schemas/document/PageData.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { DocumentQualityAssessmentValues, DocumentQualityValues, } from '../document_quality_analyzer/DocumentQualityAnalyzerTypes';
import { ParametricFilter } from '../image_processing/ParametricFilters';
import { DocumentStraighteningParameters } from './DocumentEnhancerTypes';
import { DocumentDetectionStatusValues } from './DocumentScannerTypes';
import { PageImageSourceValues } from './PageImageSource';
/**
The result of the health insurance card recognition.
*/
export class PageData {
    /** @param source {@displayType `DeepPartial<PageData>`} */
    constructor(source = {}) {
        /**
          The list of filters applied to the page.
          */
        this.filters = null;
        /**
          The polygon of the page.
          */
        this.polygon = [];
        /**
          The detection status of the page.
          */
        this.documentDetectionStatus = null;
        /**
          The deprecated quality score of the page.
          */
        this.documentQuality = null;
        /**
          The quality score of the page.
          */
        this.documentQualityAssessment = null;
        /**
          The document straightening parameters applied to the page.
          */
        this.straighteningParameters = null;
        /**
          The source of the page image.
          */
        this.source = null;
        /**
          The URI of the document image.
          */
        this.documentImageURI = null;
        /**
          The URI of the unfiltered document image.
          */
        this.unfilteredDocumentImageURI = null;
        /**
          The URI of the document image preview.
          */
        this.documentImagePreviewURI = null;
        if (source.uuid !== undefined) {
            this.uuid = source.uuid;
        }
        else {
            throw new Error('uuid must be present in constructor argument');
        }
        if (source.filters !== undefined) {
            this.filters =
                source.filters != null
                    ? source.filters.map((it) => {
                        return ParametricFilter.from(it);
                    })
                    : null;
        }
        if (source.polygon !== undefined) {
            this.polygon = source.polygon.map((it) => {
                return { x: it.x, y: it.y };
            });
        }
        if (source.documentDetectionStatus !== undefined) {
            this.documentDetectionStatus =
                source.documentDetectionStatus != null
                    ? DocumentDetectionStatusValues.includes(source.documentDetectionStatus)
                        ? source.documentDetectionStatus
                        : null
                    : null;
        }
        if (source.documentQuality !== undefined) {
            this.documentQuality =
                source.documentQuality != null
                    ? DocumentQualityValues.includes(source.documentQuality)
                        ? source.documentQuality
                        : null
                    : null;
        }
        if (source.documentQualityAssessment !== undefined) {
            this.documentQualityAssessment =
                source.documentQualityAssessment != null
                    ? DocumentQualityAssessmentValues.includes(source.documentQualityAssessment)
                        ? source.documentQualityAssessment
                        : null
                    : null;
        }
        if (source.straighteningParameters !== undefined) {
            this.straighteningParameters =
                source.straighteningParameters != null
                    ? new DocumentStraighteningParameters(source.straighteningParameters)
                    : null;
        }
        if (source.source !== undefined) {
            this.source =
                source.source != null ? (PageImageSourceValues.includes(source.source) ? source.source : null) : null;
        }
        if (source.originalImageURI !== undefined) {
            this.originalImageURI = source.originalImageURI;
        }
        else {
            throw new Error('originalImageURI must be present in constructor argument');
        }
        if (source.documentImageURI !== undefined) {
            this.documentImageURI = source.documentImageURI != null ? source.documentImageURI : null;
        }
        if (source.unfilteredDocumentImageURI !== undefined) {
            this.unfilteredDocumentImageURI =
                source.unfilteredDocumentImageURI != null ? source.unfilteredDocumentImageURI : null;
        }
        if (source.documentImagePreviewURI !== undefined) {
            this.documentImagePreviewURI = source.documentImagePreviewURI != null ? source.documentImagePreviewURI : null;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            uuid: this.uuid,
            filters: this.filters != null
                ? this.filters.map((it) => {
                    return it.serialize(config);
                })
                : null,
            polygon: this.polygon.map((it) => {
                return it;
            }),
            documentDetectionStatus: this.documentDetectionStatus != null ? this.documentDetectionStatus : null,
            documentQuality: this.documentQuality != null ? this.documentQuality : null,
            documentQualityAssessment: this.documentQualityAssessment != null ? this.documentQualityAssessment : null,
            straighteningParameters: this.straighteningParameters != null ? this.straighteningParameters.serialize(config) : null,
            source: this.source != null ? this.source : null,
            originalImageURI: this.originalImageURI,
            documentImageURI: this.documentImageURI != null ? this.documentImageURI : null,
            unfilteredDocumentImageURI: this.unfilteredDocumentImageURI != null ? this.unfilteredDocumentImageURI : null,
            documentImagePreviewURI: this.documentImagePreviewURI != null ? this.documentImagePreviewURI : null,
        };
    }
}
//# sourceMappingURL=PageData.js.map